import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';

export default class BasicFormInput extends Component {
  render() {
    const { placeholder, label, input, controlId, type, meta, readOnly } = this.props;
    return (
      <FormGroup
        controlId={controlId || ''}
        style={{ marginBottom: '10px' }}
        validationState={(meta.error && meta.touched && 'error') || null}
      >
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          readOnly={readOnly}
          type={type}
          value={input.value}
          onChange={input.onChange}
          placeholder={placeholder || ''}
          {...input}
        />
        {(meta.error && meta.touched) && <HelpBlock>{meta.error}</HelpBlock>}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

BasicFormInput.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  type: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/cms/form/BasicFormInput.js